import { getGlobalHeadersAsObject } from "../global-headers";

export interface VoyagerLogItem {
	id: number;
	created: string;
	status_code: number | null;
	bot_name: string;
	proxy_id: number | null;
	proxy_uri: string;
	resource_label: string;
	caller_type_label: string;
	content_type_label: string;
	object_id: number | null;
	url: string;
}

export interface VoyagerLogResponse {
	results: VoyagerLogItem[];
}

export async function getPersonVoyagerLog(
	personId: number
): Promise<VoyagerLogResponse> {
	const response = await fetch(`/api/v2/persons/${personId}/request_history/`, {
		method: "GET",
		headers: {
			"Content-Type": "application/json",
			...getGlobalHeadersAsObject(),
		},
	});

	if (!response.ok) {
		throw new Error(`Failed to fetch voyager log: ${response.status}`);
	}

	return response.json();
}

export async function getCompanyVoyagerLog(
	companyId: number
): Promise<VoyagerLogResponse> {
	const response = await fetch(`/api/v2/companies/${companyId}/request_history/`, {
		method: "GET",
		headers: {
			"Content-Type": "application/json",
			...getGlobalHeadersAsObject(),
		},
	});

	if (!response.ok) {
		throw new Error(`Failed to fetch company voyager log: ${response.status}`);
	}

	return response.json();
}
